import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { CheckoutFinalize } from "src/app/models/enrollment-checkout";
import { FileUploadService } from "src/app/services/file-upload.service";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-finalize',
    templateUrl: './finalize.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutFinalizeComponent implements OnInit {
    @ViewChild('vcSigPad', { static: true }) signaturePadElement: any;
    @Input() public checkoutFinalize: CheckoutFinalize;

    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public isComplete: boolean;
    public signatureBlob: Blob;

    constructor(
        private fileUploadService: FileUploadService,
    ) {
    }

    ngOnInit(): void {
    }

    public signatureComplete($event: Blob): void {
        this.signatureBlob = $event;
        this.isComplete = true;
    }

    public signatureCancel(): void {
        this.isComplete = false;
        this.signatureBlob = null;
    }

    public otpComplete(): void {
        this.isComplete = true;
    }

    public complete(): void {
        if (this.checkoutFinalize.showSignature) {
            this.fileUploadService.uploadCheckoutSignature(this.signatureBlob).subscribe(() => {
                this.emitComplete.emit();
            });
        } else {
            this.emitComplete.emit();
        }
    }
}